import { render, staticRenderFns } from "./sub-sider-bar.vue?vue&type=template&id=ee7519b4&"
import script from "./sub-sider-bar.vue?vue&type=script&lang=js&"
export * from "./sub-sider-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports